export const CoreMainPalette: any = {
    0: '#515B69',
    1: '#F23F6A',
    2: '#F23F6A',
    3: '#DE35C1',
    4: '#7F5AF2',
    5: '#7F5AF2',
    6: '#28AFF0',
    7: '#28AFF0',
    8: '#28AFF0',
    9: '#00C9B2',
    10: '#43C464',
    11: '#43C464',
    12: '#43C464',
    13: '#00C9B2',
    14: '#F5B800',
    15: '#FF841F',
    16: '#FF6157',
    17: '#515B69',
    18: '#515B69',
    19: '#B57A5C',
    20: '#3F74FC',
    21: '#3F74FC',
    22: '#7F5AF2',
    23: '#515B69',
    24: '#7F5AF2',
    25: '#515B69',
    26: '#F23F6A',
    27: '#294BFD',
    28: '#28D8F0',
    29: '#4CDB9C',
    30: '#199F4E',
    31: '#A8DE35',
    32: '#EF3F3C',
    33: '#FF59BD',
    34: '#A829BD',
    35: '#780BBB',
    36: '#653BBE',
    37: '#A74646',
    38: '#654747',
}

export const CoreMainBorderPalette: any = {
    0: '#47505C',
    1: '#E61E6F',
    2: '#E61E6F',
    3: '#C926AD',
    4: '#6E45ED',
    5: '#6E45ED',
    6: '#0CA0E9',
    7: '#0CA0E9',
    8: '#0CA0E9',
    9: '#00BDA7',
    10: '#39B458',
    11: '#39B458',
    12: '#39B458',
    13: '#00BDA7',
    14: '#E5AC00',
    15: '#EC720E',
    16: '#E8493F',
    17: '#47505C',
    18: '#47505C',
    19: '#A5694B',
    20: '#2661F7',
    21: '#2661F7',
    22: '#6E45ED',
    23: '#47505C',
    24: '#6E45ED',
    25: '#47505C',
    26: '#E61E6F',
    27: '#1436E8',
    28: '#00BFD9',
    29: '#3FC88C',
    30: '#138C44',
    31: '#8DC21C',
    32: '#CE2623',
    33: '#E2399F',
    34: '#8F10A3',
    35: '#63059D',
    36: '#4D24A3',
    37: '#8E3333',
    38: '#523131',
}

